import {
  NBS_API_GET_VIEWED_ME_SUCCESS,
  NBS_API_BLOCK_USER_SUCCESS,
  NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS,
  RESET_GET_VIEWED_ME_OPENED,
  RESET_GET_VIEWED_ME_SEEN,
} from '../../constants/actions';

const initialState = {
  data: [],
  lastUserId: '',
  end: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_VIEWED_ME_SUCCESS:
      const currentState = { ...state };
      const { users, end } = action.response;
      const lastUserId = end ? '' : users[users.length - 1].user_id;

      if (action.silent) {
        return {
          data: action.response.users,
          end,
          lastUserId,
        };
      } else {
        return { lastUserId, end, data: [...currentState.data, ...users] };
      }
    case NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS:
    case NBS_API_BLOCK_USER_SUCCESS:
      const currentUsers = [...state.data];
      const newUsers = currentUsers.filter(
        (user) => user.user_id !== action.userId
      );
      return { ...state, data: newUsers };
    case RESET_GET_VIEWED_ME_OPENED:
      const newData = [];
      state.data.forEach((user) => {
        if (user.user_id === action.userId) {
          user.unopened = false;
        }
        newData.push(user);
      });
      return { ...state, data: newData };
    case RESET_GET_VIEWED_ME_SEEN:
      const newListData = [];
      state.data.forEach((user) => {
        user.unseen = false;
        newListData.push(user);
      });
      return { ...state, data: newListData };
    default:
      return state;
  }
}
